class SplitSlideshow extends HTMLElement {
  constructor() {
    super();

    this.track = this.querySelector('.split-slideshow__track');
    this.slides = Array.from(this.querySelectorAll('[data-slide]'));
    this.counters = Array.from(this.querySelectorAll('[data-counter]'));

    this.currentIndex = 0;

    this.update();
    this.bindArrows();
  }

  update() {
    this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;


    this.counters.forEach(counter => {
      counter.textContent = `${this.currentIndex + 1}/${this.slides.length}`;
    });
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    this.update();
  }

  prev() {
    this.currentIndex =
      (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    this.update();
  }

  bindArrows() {
    this.querySelectorAll('[data-prev]').forEach(btn =>
      btn.addEventListener('click', () => this.prev())
    );

    this.querySelectorAll('[data-next]').forEach(btn =>
      btn.addEventListener('click', () => this.next())
    );
  }
}

customElements.define('split-slideshow', SplitSlideshow);
